// extracted by mini-css-extract-plugin
export default {"container":"Loading_container__UT5cj","spinner":"Loading_spinner__s5eU9","spin":"Loading_spin__sCrfu","loadingText":"Loading_loadingText__yFjbX"};